import PharmaAndLabOrderService from "../../Services/PharmaAndLabOrderService";


export const FETCH_PHARMACYORDERS_REQUEST = "FETCH_PHARMACYORDERS_REQUEST";
export const FETCH_PHARMACYORDERS_SUCCESS = "FETCH_PHARMACYORDERS_SUCCESS";
export const FETCH_PHARMACYORDERS_FAILURE = "FETCH_PHARMACYORDERS_FAILURE";

export const FETCH_LABORDERS_REQUEST = "FETCH_LABORDERS_REQUEST";
export const FETCH_LABORDERS_SUCCESS = "FETCH_LABORDERS_SUCCESS";
export const FETCH_LABORDERS_FAILURE = "FETCH_LABORDERS_FAILURE";


export const fetchPharmacyOrders = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_PHARMACYORDERS_REQUEST });
    try {
        const response = await PharmaAndLabOrderService.getMedicineOrdersList(payload);
        dispatch({ type: FETCH_PHARMACYORDERS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_PHARMACYORDERS_FAILURE, payload: error.message });
    }
}

export const fetchLabOrders = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_LABORDERS_REQUEST });
    try {
        const response = await PharmaAndLabOrderService.getLabOrdersList(payload);
        dispatch({ type: FETCH_LABORDERS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_LABORDERS_FAILURE, payload: error.message });
    }
}

